import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

// Chakra imports
import {
  Flex,
  Heading,
  Table,
  TableContainer,
  Thead,
  Th,
  Tr,
  Td,
  Text,
  Tbody,
  Button,
  Badge,
  Box,
  Input,
  Skeleton,
  Spinner,
  SkeletonText,
} from "@chakra-ui/react";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardBody from "components/Card/CardBody";
import { usePaginateComponent } from "components/Pagination/pagination";
import { getOrderTransactions } from "service/order.service";
import { BsEye } from "react-icons/bs";
import moment from "moment";

export default function Order() {
  //variables
  const history = useHistory();
  const [orders, setOrders] = useState([]);
  const [searchOrder, setSearchOrder] = useState("");
  const {
    pagination,
    setPagination,
    PaginationComponent,
    updatePagination,
  } = usePaginateComponent();
  const [loading, setLoading] = useState(false);

  const PAYMENT_RELEASE_STATUS_COLOR = {
    completed: "green.400",
    not_required: "black",
    incomplete: "yellow.500",
  };

  const ORDER_STATUS_COLOR = {
    completed: "green.400",
    to_review: "yellow.500",
    cancelled: "red",
    refund: "purple.500",
  };

  const DELIVERY_STATUS_COLOR = {
    completed: "green.400",
    cancelled: "red",
    none: "black",
    auto_completed: "yellow.500",
    failed: "purple.500",
  };

  //methods
  const getOrders = async (page) => {
    try {
      setOrders([]);
      setLoading(true);

      const { data } = await getOrderTransactions(page ?? 1, searchOrder);

      setLoading(false);

      setPagination(updatePagination(data));

      setOrders(data);
    } catch (error) {
      console.log(error);
    }
  };

  //setup methods
  useEffect(() => {
    getOrders();
  }, [searchOrder]);

  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
      <Card>
        <CardHeader>
          {/* <Heading>Order Table</Heading> */}
          <Box p={"2"} w={"full"}>
            <Input
              placeholder={"Search. . ."}
              onChange={(e) => {
                setSearchOrder(e.target.value);
              }}
              textColor={"black"}
              bg={"white"}
            />
          </Box>
          <PaginationComponent pagination={pagination} getListData={getOrders} />
        </CardHeader>

        <CardBody>
          <TableContainer
            overscroll={"auto"}
            maxH={"2xl"}
            overflowY="scroll"
            position="relative"
            w={"full"}
          >
            <Table>
              <Thead
                position="sticky"
                top="0"
                zIndex="sticky"
                bg="gray.900"
                color="whiteAlpha.900"
              >
                <Tr>
                  <Th rowSpan={2} textAlign={"center"}>
                    <Text textColor={"cyan.300"} fontSize={"medium"}>
                      Hirer
                    </Text>
                  </Th>
                  <Th
                    rowSpan={2}
                    textAlign={"center"}
                    borderLeft={"1px"}
                    borderRight={"1px"}
                  >
                    <Text textColor={"limegreen"} fontSize={"medium"}>
                      Gigger
                    </Text>
                  </Th>
                  <Th colSpan={"9"} textAlign={"center"} borderLeft={"1px"}>
                    <Text textColor={"pink.400"} fontSize={"medium"}>
                      Order
                    </Text>
                  </Th>
                </Tr>
                <Tr>
                  {/*              Order Detail           */}
                  <Th>
                    <Text
                      textColor={"whiteAlpha.900"}
                      fontSize={"x-small"}
                      textAlign={"center"}
                    >
                      Payment Date
                    </Text>
                  </Th>
                  <Th>
                    <Text
                      textColor={"whiteAlpha.900"}
                      fontSize={"x-small"}
                      textAlign={"center"}
                    >
                      Status
                    </Text>
                  </Th>
                  <Th>
                    <Text
                      textColor={"whiteAlpha.900"}
                      fontSize={"x-small"}
                      textAlign={"center"}
                    >
                      Delivery Status
                    </Text>
                  </Th>
                  <Th>
                    <Text
                      textColor={"whiteAlpha.900"}
                      fontSize={"x-small"}
                      textAlign={"center"}
                    >
                      Complete Date
                    </Text>
                  </Th>
                  <Th>
                    <Text
                      textColor={"whiteAlpha.900"}
                      fontSize={"x-small"}
                      textAlign={"center"}
                    >
                      Billplz Reference: <br /> Order Payment No.
                    </Text>
                  </Th>
                  <Th>
                    <Text
                      textColor={"whiteAlpha.900"}
                      fontSize={"x-small"}
                      textAlign={"center"}
                    >
                      Billplz Reference: <br /> Bill Code
                    </Text>
                  </Th>
                  <Th>
                    <Text
                      textColor={"whiteAlpha.900"}
                      fontSize={"x-small"}
                      textAlign={"center"}
                    >
                      Refund / Release <br /> Payment Status
                    </Text>
                  </Th>
                  <Th>
                    <Text
                      textColor={"whiteAlpha.900"}
                      fontSize={"x-small"}
                      textAlign={"center"}
                    >
                      Referrer <br />Payment Status
                    </Text>
                  </Th>
                  <Th>
                    <Text
                      textColor={"whiteAlpha.900"}
                      fontSize={"x-small"}
                      textAlign={"center"}
                    >
                      -
                    </Text>
                  </Th>
                </Tr>
              </Thead>

              <Tbody>
                {loading && (
                  <Tr justifyContent={"center"} w={"full"} h={"full"}>
                    <Td colSpan={11}>
                      {/* <Box w={"full"} textAlign={"center"} bg={"gray.100"} opacity={"0.2"}> */}
                      <Skeleton h={"20px"} w={"full"} my={"10"} />
                      <Skeleton h={"20px"} w={"full"} my={"10"} />
                      <Skeleton h={"20px"} w={"full"} my={"10"} />
                      {/* </Box> */}
                    </Td>
                  </Tr>
                )}
                {orders.data &&
                  orders.data.map((order, index) => {
                    return (
                      <Tr textColor={"whiteAlpha.900"} fontSize={"small"} key={index}>
                        {/*              Hirer Detail           */}
                        <Td textAlign={"center"}>
                          <Text>{order?.hirer?.full_name}</Text>
                        </Td>
                        {/*              Gigger Detail           */}
                        <Td textAlign={"center"}>
                          <Text>{order?.gigger?.full_name}</Text>
                        </Td>

                        {/*              Order Detail           */}
                        <Td textAlign={"center"}>
                          <Text>
                            {moment(order?.pay_date?.created_at).format("YYYY-MM-DD") ??
                              ""}
                          </Text>
                        </Td>
                        <Td textAlign={"center"}>
                          <Badge
                            bg={ORDER_STATUS_COLOR[order?.order_status] ?? "black"}
                            color={"white"}
                            fontSize="xs"
                            p="3px 10px"
                            borderRadius="8px"
                            border={"none"}
                            fontWeight="normal"
                            textTransform={"uppercase"}
                          >
                            {order?.order_status == "to_review"
                              ? "Completed"
                              : order?.order_status}
                          </Badge>
                        </Td>
                        <Td textAlign={"center"}>
                          <Badge
                            bg={DELIVERY_STATUS_COLOR[order?.delivery_status] ?? "black"}
                            color={"white"}
                            fontSize="xs"
                            p="3px 10px"
                            borderRadius="8px"
                            border={"none"}
                            fontWeight="normal"
                            textTransform={"uppercase"}
                          >
                            {order?.delivery_status}
                          </Badge>
                        </Td>
                        <Td textAlign={"center"}>
                          <Text>
                            {order?.complete_date
                              ? moment(order?.complete_date).format("YYYY-MM-DD")
                              : ""}
                          </Text>
                        </Td>
                        <Td textAlign={"center"}>
                          <Text>{order?.transactions?.payment_no}</Text>
                        </Td>
                        <Td textAlign={"center"}>
                          <Text>{order?.transactions?.gateway_bill_code}</Text>
                        </Td>
                        <Td textAlign={"center"}>
                          <Badge
                            bg={
                              PAYMENT_RELEASE_STATUS_COLOR[order?.payment_release_status]
                            }
                            color={"white"}
                            fontSize="xs"
                            p="3px 10px"
                            borderRadius="8px"
                            border={"none"}
                            fontWeight="normal"
                            textTransform={"uppercase"}
                          >
                            {order?.payment_release_status}
                          </Badge>
                        </Td>
                        <Td textAlign={"center"}>
                          <Badge
                            bg={
                              PAYMENT_RELEASE_STATUS_COLOR[order?.referrer_payment_status]
                            }
                            color={"white"}
                            fontSize="xs"
                            p="3px 10px"
                            borderRadius="8px"
                            border={"none"}
                            fontWeight="normal"
                            textTransform={"uppercase"}
                          >
                            {order?.referrer_payment_status}
                          </Badge>
                        </Td>
                        <Td textAlign={"center"}>
                          <Button
                            bg={"gray.900"}
                            onClick={() => {
                              history.push({
                                pathname: `/admin/order/detail/${order?.id}`,
                                state: order?.order_attendance_id,
                              });
                            }}
                          >
                            <BsEye />
                          </Button>
                        </Td>
                      </Tr>
                    );
                  })}
              </Tbody>
            </Table>
          </TableContainer>
        </CardBody>
      </Card>
    </Flex>
  );
}
